/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const faqsService = async () => {
  return api('/api/v2/pages/?type=FAQ.FAQPage&fields=questions(title,text)', {}, 'GET');
};


export {
  faqsService,
};
